import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-post",
  "use": "icon-post-usage",
  "viewBox": "0 0 18 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 24\" id=\"icon-post\"><g stroke=\"#000\" stroke-width=\"1.25\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.252.625h9.773a3.627 3.627 0 013.627 3.627V23.69\" /><path d=\"M.625 23.691V4.252a3.627 3.627 0 017.254 0v19.44M7.879 5.534h9.773M11.403 9.165h2.622M14.026.625v4.909M.625 21.235h17.027\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol